export default __webpack_public_path__ + "static/open-sans-v15-latin-regular-61747992dd9a412e601e3defa3f3baa6.ttf";